import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePostTag } from "../../../api/apiBlog";
import { toast } from "react-hot-toast";

export const useDeletePostTag = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteTagMutate, isPending: isDeleting } = useMutation({
        mutationFn: deletePostTag,
        onSuccess: (res) => {
            toast.success(res.message || "Tag deleted successfully");
            queryClient.invalidateQueries(["post-tags"]);
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Error deleting tag");
        },
    });

    return { deleteTagMutate, isDeleting };
};
